import React, { type FC, type ReactNode, useEffect, useRef, useState } from "react";
import DragBar from "./DragBar.tsx";
import { styled } from "@linaria/react";

interface SplitViewProps {
  children: ReactNode;
}

const SplitViewWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
`;

const MainWrapper = styled.main`
  will-change: width;
`;

interface ResetEvent {
  clientX: number;
}

// TODO: This was pulled off an old project
// This needs a HUGE cleanup
const SplitView: FC<SplitViewProps> = (props) => {
  // const dragBarRef = useRef<Element>(null);
  const [leftWidth, setLeftWidth] = useState<string | number>("35%");
  const [rightWidth, setRightWidth] = useState<string | number>("65%");

  const size = React.Children.count(props.children);
  console.assert(size === 2, `<SplitView> only allows 2 child elements (got ${size})`);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const left = props.children[0];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const right = props.children[1];

  const lastDragWidth = useRef(0);
  const lastTimeout = useRef<number | null>(null);

  const onDrag = (
    e: React.DragEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement> | UIEvent | ResetEvent,
  ) => {
    // Could have used a ? : but typescript doesn't like that
    let x = lastDragWidth.current;
    if ("targetTouches" in e) x = e.targetTouches[0].pageX;
    else if ("clientX" in e) x = e.clientX;

    if (x == 0) return;

    lastDragWidth.current = x;

    const leftWidth = x;
    const rightWidth = window.innerWidth - leftWidth;

    // Chrome bug? Dragging likes to jump to 0
    if (leftWidth !== 0) {
      setLeftWidth(`${leftWidth}px`);
      setRightWidth(`${rightWidth}px`);
    }

    if (lastTimeout.current != null) clearTimeout(lastTimeout.current);

    const timeoutId = setTimeout(() => {
      window.dispatchEvent(new Event("dragbarResize"));
      lastTimeout.current = null;
    }, 25);

    lastTimeout.current = Number(timeoutId);
  };

  const onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "none";

    // Firefox refuses to send drag client position
    // https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (navigator.userAgent.includes("Firefox")) {
      onDrag(e);
    }
  };

  // TODO: A small hack that's not very 'react', fix that
  // We need a way to reset the drag bar sometimes
  useEffect(() => {
    const func = () => {
      const reset: ResetEvent = {
        clientX: 400,
      };
      onDrag(reset);
    };
    window.addEventListener("dragbar-reset", func);

    return () => {
      window.removeEventListener("dragbar-reset", func);
    };
  }, []);

  useEffect(() => {
    const func = (e: UIEvent) => {
      onDrag(e);
    };

    window.addEventListener("resize", func, { passive: true });

    return () => {
      window.removeEventListener("resize", func);
    };
  }, []);

  return (
    <SplitViewWrapper>
      <MainWrapper
        style={{
          width: leftWidth,
          overflow: "auto",
          minWidth: "250px",
          scrollbarWidth: "none",
        }}
        onDragOver={onDragOver}
      >
        {left}
      </MainWrapper>
      <DragBar dragCallback={onDrag} />
      <MainWrapper
        style={{
          width: rightWidth,
          overflow: "auto",
          zIndex: 10,
          minWidth: "250px",
          scrollbarWidth: "none",
        }}
        onDragOver={onDragOver}
      >
        {right}
      </MainWrapper>
    </SplitViewWrapper>
  );
};

export default SplitView;
